import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createSlots as _createSlots, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "menu-container" }
const _hoisted_2 = ["href"]
const _hoisted_3 = {
  key: 1,
  class: "mobile-menu-wrapper"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "mobile-dropdown-menu" }
const _hoisted_6 = ["href"]

import { ref, onMounted, onUnmounted } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'boxTop',
  props: {
  isType: {
    type: String
  },
  list: {
    type: Array
  }
},
  setup(__props) {

const props = __props;

const isMobile = ref(false);
const activeIndex = ref<number | null>(null);

// 检测是否为移动端
const checkMobile = () => {
  isMobile.value = window.innerWidth <= 768;
};

// 切换菜单显示
const toggleMenu = (index: number) => {
  activeIndex.value = activeIndex.value === index ? null : index;
};

// 关闭菜单
const closeMenu = (index: number) => {
  if (activeIndex.value === index) {
    activeIndex.value = null;
  }
};

// 点击外部关闭菜单的自定义指令
const vClickOutside = {
  mounted(el: HTMLElement, binding: any) {
    el.clickOutsideEvent = (event: MouseEvent) => {
      if (!(el === event.target || el.contains(event.target as Node))) {
        binding.value();
      }
    };
    document.addEventListener('click', el.clickOutsideEvent);
  },
  unmounted(el: HTMLElement) {
    document.removeEventListener('click', el.clickOutsideEvent);
  }
};

onMounted(() => {
  checkMobile();
  window.addEventListener('resize', checkMobile);
});

onUnmounted(() => {
  window.removeEventListener('resize', checkMobile);
});

return (_ctx: any,_cache: any) => {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!isMobile.value)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.list, (item, i) => {
          return (_openBlock(), _createBlock(_component_el_dropdown, {
            key: i,
            placement: __props.isType,
            "hide-on-click": false,
            class: "desktop-dropdown"
          }, _createSlots({
            default: _withCtx(() => [
              _createElementVNode("p", null, _toDisplayString(item.label), 1)
            ]),
            _: 2
          }, [
            (!!item?.children)
              ? {
                  name: "dropdown",
                  fn: _withCtx(() => [
                    _createVNode(_component_el_dropdown_menu, null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (items, idx) => {
                          return (_openBlock(), _createBlock(_component_el_dropdown_item, { key: idx }, {
                            default: _withCtx(() => [
                              _createElementVNode("a", {
                                href: items.link,
                                target: "_blank"
                              }, _toDisplayString(items.label), 9, _hoisted_2)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["placement"]))
        }), 128))
      : _createCommentVNode("", true),
    (isMobile.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (item, i) => {
            return _withDirectives((_openBlock(), _createElementBlock("div", {
              key: 'mobile-' + i,
              class: _normalizeClass(["mobile-dropdown", { 'half-width': ['政府网站', '兄弟学会'].includes(item.label) }])
            }, [
              _createElementVNode("p", {
                onClick: ($event: any) => (toggleMenu(i))
              }, _toDisplayString(item.label), 9, _hoisted_4),
              _withDirectives(_createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (items, idx) => {
                  return (_openBlock(), _createElementBlock("a", {
                    key: idx,
                    href: items.link,
                    target: "_blank",
                    class: "mobile-dropdown-item"
                  }, _toDisplayString(items.label), 9, _hoisted_6))
                }), 128))
              ], 512), [
                [_vShow, activeIndex.value === i && !!item?.children]
              ])
            ], 2)), [
              [vClickOutside, () => closeMenu(i)]
            ])
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})